var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Achievements'),_c('CardList',{attrs:{"cards":_vm.cards}}),(_vm.loading)?_c('Spinner',{staticClass:"offer-spinner",attrs:{"size":"large","color":"red"}}):_c('OffersSection',{attrs:{"offers":_vm.lastActiveOffers}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }